import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VmePipesModule } from '../../../../vme-pipes.module';
import { JobScreenCarryOverTask } from '../../../../interfaces/screen-specific/job-screen';
import { TaskSupplierScheduleStore } from '../../../task-supplier-schedule/task-supplier-schedule-store';

@Component({
  selector: 'app-carryover-task-info',
  standalone: true,
  imports: [CommonModule, VmePipesModule],
  template: `
    <div class="make-model">{{ task.vehicle.make }} {{ task.vehicle.model }}</div>
    <div>
      <i class="fa fa-calendar"></i>
      <span *ngIf="task.taskSupplierSchedule">
        {{ task.taskSupplierSchedule?.specifiedPickUpTime | datex : 'HH:mm ddd Do' }}
      </span>
      <span
        *ngIf="
          taskSupplierScheduleStores &&
          !task.taskSupplierSchedule &&
          taskSupplierScheduleStores[task.id]
        "
      >
        {{ taskSupplierScheduleStores[task.id].pickUp.scheduledTime | datex : 'HH:mm ddd Do' }}
      </span>
      -
      <span *ngIf="task.taskSupplierSchedule">
        {{ task.taskSupplierSchedule?.specifiedDropOffTime | datex : 'HH:mm ddd Do' }}
      </span>
      <span
        *ngIf="
          taskSupplierScheduleStores &&
          !task.taskSupplierSchedule &&
          taskSupplierScheduleStores[task.id]
        "
      >
        {{ taskSupplierScheduleStores[task.id].dropOff.scheduledTime | datex : 'HH:mm ddd Do' }}
      </span>
    </div>
  `,
  styles: [
    `
      .make-model {
        font-weight: 500;
        margin-bottom: 2px;
      }
    `,
  ],
})
export class CarryoverTaskInfoComponent {
  @Input() task!: JobScreenCarryOverTask;
  @Input() taskSupplierScheduleStores?: Record<string, TaskSupplierScheduleStore>;
}
